<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../../assets/images/banner_list.jpg" />
            <div class="btext">
                <h3>通知公告</h3>
                <p>最新金融快讯，全球投资信息，行业特色综合类新闻资讯</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资讯中心</el-breadcrumb-item>
                <el-breadcrumb-item>通知公告</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="1"
                            class="el-menu-vertical-demo">
                        <router-link :to="{ path: '/notificationAnnouncement' }">
                            <el-menu-item index="1"><span slot="title" >通知公告</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/centerNews' }">
                            <el-menu-item index="2"><span slot="title">中心新闻</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/industryInformation' }">
                            <el-menu-item index="3"><span slot="title">行业资讯</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/investmentExpress' }">
                            <el-menu-item index="4"><span slot="title" >投资快讯</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/communicationCooperation' }">
                            <el-menu-item index="5"><span slot="title">交流合作</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/caseShow' }">
                            <el-menu-item index="6"><span slot="title">案例展示</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="news_detail">
                            <h1 class="title_news" v-if="showDetail">{{this.NotificationAnnouncementDetail.title}}</h1>
                            <div class="date_news" v-if="showDetail">发布日期：{{this.NotificationAnnouncementDetail.publishTime|date_from_unix_YearMonthDay}} &nbsp;&nbsp;&nbsp;&nbsp;发布人：{{this.NotificationAnnouncementDetail.publisher}}</div>
                            <div class="content_news" v-html="this.NotificationAnnouncementDetail.content"></div>

                            <div class="news_more" v-if="showDetail">
                                <a class="prev" v-on:click="getPrevious(NotificationAnnouncementDetail.rownum)" v-bind:class="{temporary: NotificationAnnouncementDetail.rownum==1}"><b>上一篇：</b>{{this.NotificationAnnouncementDetail.rownum==1?'没有上一篇':perviousTitle}}</a>
                                <a class="next" v-on:click="getNext(NotificationAnnouncementDetail.rownum)" v-bind:class="{temporary: NotificationAnnouncementDetail.rownum==this.lastOne}"><b>下一篇：</b>{{this.NotificationAnnouncementDetail.rownum==this.lastOne?'没有下一篇':nextTitle}}</a>
                                <div class="clear"></div>
                            </div>

                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqNotificationAnnouncementById,reqNotificationAnnouncementPervious,reqNotificationAnnouncementNext} from "../../../../api/contentManagement-api";
    export default {
        data(){
            return{
                NotificationAnnouncementDetail:[],
                showDetail:true,
                perviousTitle:'',
                nextTitle:'',
                lastOne:'',
            }
        },
        methods:{
            getNotificationAnnouncementDetail(id){
                reqNotificationAnnouncementById({id:id}).then((res)=>{
                    if(res.data.code===1){
                        this.NotificationAnnouncementDetail=res.data.data;
                        this.getPerviousTitle(this.NotificationAnnouncementDetail.rownum);
                        this.getNextTitle(this.NotificationAnnouncementDetail.rownum);
                    }else{
                        this.NotificationAnnouncementDetail='<p>抱歉，暂无数据</p>';
                        this.showDetail=false;
                    }
                })
            },

            getPerviousTitle:function (rownum) {
                reqNotificationAnnouncementPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                    }
                })
            },
            getNextTitle:function (rownum) {
                reqNotificationAnnouncementNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.nextTitle=res.data.data.title;
                    }
                })
            },

//   上下篇内容
            getPrevious:function (rownum) {
                reqNotificationAnnouncementPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.NotificationAnnouncementDetail=res.data.data;
                        this.getPerviousTitle(this.NotificationAnnouncementDetail.rownum);
                        this.getNextTitle(this.NotificationAnnouncementDetail.rownum);
                    }
                })
            },
            getNext:function (rownum) {
                reqNotificationAnnouncementNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.NotificationAnnouncementDetail=res.data.data;
                        this.getPerviousTitle(this.NotificationAnnouncementDetail.rownum);
                        this.getNextTitle(this.NotificationAnnouncementDetail.rownum);
                    }
                })
            },

        },
        mounted(){
            var total=this.$route.query.total;
            this.lastOne=total;
            var id=this.$route.query.id;
            this.getNotificationAnnouncementDetail(id);
        },
    }

</script>
<style>

    .news_more {
        line-height: 1.6em; padding:24px 0; margin-top:24px;
    }
    .prev {
        float: left;
    }
    .next {
        float: right; text-align: right;
    }
    .temporary {
        pointer-events: none;
        filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
        -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
        opacity: 0.5; /*其他，透明度50%*/
    }
</style>


// WEBPACK FOOTER //
// src/components/contentManagement/referenceCenter/notificationAnnouncement/NotificationAnnouncementDetail.vue